import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'radius-bottom-right', 'RadiusBottomRight', [["path",{"d":"M19 5v6a8 8 0 0 1 -8 8h-6","key":"svg-0"}]]);